module.exports = __webpack_public_path__ + "static/media/playstore.b4909a3e.png";